import { memo, useMemo } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons'

import useSelector from '@hooks/useSelector'
import { generateUrls } from '@hooks/useProviderAccount'
import { Link, Table, Text } from '@domain-group/suit-theme'

import type { AgencyModel, ProviderAccountModel } from '@models/types'

const renderTerms = (terms: string | undefined) => {
  if (terms === 'cash') return 'Cash'
  if (terms) return `${terms} Days`
  return 'Not Set'
}

const buildColumns = (providerAccounts: ProviderAccountModel[]) => [
  {
    title: 'Agency',
    dataKey: 'title',
    cellProps: {
      position: 'sticky',
      left: 0,
    },
    render: (title: string, agency: Partial<AgencyModel>) => {
      const { editProviderAccountUrl } = generateUrls({ agency_id: agency.id })

      return (
        <Link
          href={editProviderAccountUrl}
          textProps={{
            display: 'inline-block',
            variant: 'ellipsis',
          }}
        >
          {title}
        </Link>
      )
    },
  },
  {
    title: 'Email',
    dataKey: 'email',
    render: (email: string) => (
      <Text minWidth="fit-content" variant="ellipsis">
        {email}
      </Text>
    ),
  },
  {
    title: 'Phone',
    dataKey: 'phone',
    render: (phone: string) => (
      <Text minWidth="fit-content" variant="ellipsis">
        {phone}
      </Text>
    ),
  },
  {
    title: 'Terms',
    dataKey: 'provider_account_id',
    render: (providerAccountId: number) => {
      const providerAccount = providerAccounts[providerAccountId]
      return (
        <Text minWidth="fit-content" variant="ellipsis">
          {renderTerms(providerAccount?.terms)}
        </Text>
      )
    },
  },
  {
    title: 'Account Lock Enabled',
    dataKey: 'provider_account_id',
    cellProps: {
      textAlign: 'center',
    },
    render: (providerAccountId: number) => {
      const providerAccount = providerAccounts[providerAccountId]
      return (
        <FontAwesomeIcon icon={providerAccount?.enable_account_lock ? faCheck : faTimes} />
      )
    },
  },
]

const ProviderAccountsTable = (props: { filteredAgencies:AgencyModel[] }) => {
  const { filteredAgencies } = props

  const { providerAccounts } = useSelector(reduxState => reduxState.entities)

  // @ts-expect-error TS2345
  const memoColumns = useMemo(() => buildColumns(providerAccounts), [filteredAgencies.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      data={filteredAgencies}
      stickyHeader
    />

  )
}

export default memo(ProviderAccountsTable)
